module.exports = __webpack_public_path__ + "img/flot5.95146cef.svg";